import React from "react";
import styles from "./PlaygroundSideActions.module.scss";
import IcDownload from "./IcDownload.svg";
import { useADSContext } from "../../../../../../../../../../context/ADSProvider";
import useDownloadImage from "../../../../../../../../../../hooks/useDownloadImage";
import { Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";
import { tooltipClasses } from "@mui/material/Tooltip";
import Enlarge from "./Enlarge";
import ImageEditorToolbar from "./Component/ImageEditorToolbar";
import { useImageEditorContext } from "../../../../../../../../../../context/ImageEditorProvider";
import ImageEditorSlider from "./Component/ImageEditorSlider";
import ImageEditorTextControl from "./Component/ImageEditorTextControl";
import ImageEditorDrawControl from "./Component/ImageEditorDrawControl";
import { useAIToolsContext } from "../../../../../../../../../../context/AIToolsProvider";

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#FB4764",
    boxShadow: theme.shadows[1],
    fontSize: 12,
    fontWeight: 400,
    color: "#FFFFFF",

    ".MuiTooltip-arrow": {
      color: "#FB4764",
    },
  },
}));

const PlaygroundSideActions = () => {
  const downloadImage = useDownloadImage();
  const { firstSelectedImage } = useAIToolsContext();
  const { selectedProduct } = useADSContext();
  const {
    isEditingImage,
    ActiveToolbarId,
    SliderVal,
    TextSize,
    ShowSlider,
    ShowTextControl,
    ShowDrawControl,
    handleChangeSliderValue,
    setTextSize,
    TextColor,
    setTextColor,
    DrawColor,
    setDrawColor,
  } = useImageEditorContext();

  const localDownload = () => {
    const reader = new FileReader();

    reader.onload = function (e) {
      // Create a temporary anchor element
      const downloadLink = document.createElement("a");

      // Set properties
      downloadLink.href = e.target.result;
      downloadLink.download = firstSelectedImage.name;

      // Append to body (required for Firefox)
      document.body.appendChild(downloadLink);

      // Programmatically click the link to trigger the download
      downloadLink.click();

      // Clean up: remove the element after a slight delay
      setTimeout(() => {
        document.body.removeChild(downloadLink);
      }, 100);
    };

    // Read the file as Data URL
    reader.readAsDataURL(firstSelectedImage);
  };

  const handleDownloadImage = () => {
    if (firstSelectedImage) {
      localDownload();
      return;
    }

    downloadImage({
      path: selectedProduct.imageUrl,
      filename: selectedProduct.name,
    });
  };

  const handleIncrement = () => {
    setTextSize((prev) => (prev + 1 > 100 ? 100 : prev + 1));
  };

  const handleDecrement = () => {
    setTextSize((prev) => (prev - 1 < 0 ? 0 : prev - 1));
  };

  return (
    <>
      {isEditingImage && (
        <>
          <div className={styles.leftActionsWrapper}>
            <ImageEditorToolbar />
          </div>

          <div className={styles.bottomActionsWrapper}>
            {ShowSlider && (
              <ImageEditorSlider
                style={{ top: 16 }}
                value={SliderVal[ActiveToolbarId.ChildId]}
                onChange={(_, newVal) => handleChangeSliderValue(newVal)}
              />
            )}

            {ShowTextControl && (
              <ImageEditorTextControl
                TextSize={TextSize}
                Color={TextColor}
                onChangeColor={(e) => setTextColor(e.target.value)}
                onDecrement={handleDecrement}
                onIncrement={handleIncrement}
              />
            )}

            {ShowDrawControl && (
              <ImageEditorDrawControl
                Color={DrawColor}
                onChangeColor={(e) => setDrawColor(e.target.value)}
                onDecrement={handleDecrement}
                onIncrement={handleIncrement}
              />
            )}
          </div>
        </>
      )}

      <div className={styles.rightActionsWrapper}>
        <Enlarge />

        <LightTooltip title="Download" arrow placement="right">
          <img
            src={IcDownload}
            alt="download"
            className={styles.icon}
            onClick={handleDownloadImage}
          />
        </LightTooltip>
      </div>
    </>
  );
};

export default PlaygroundSideActions;
